<template>
  <div id="stripe-session-container" />
</template>

<script>
import { loadConnectAndInitialize } from '@stripe/connect-js'
import { stripeAPIToken, stripeStandardConnectApiToken } from 'src/config'

export default {
  name: 'StripeSessionAccount',
  props: {
    type: {
      type: String,
      required: true
    },
    stripeConfigurationId: {
      type: Number,
      required: false,
      default: null
    },
    isActive: {
      type: Boolean,
      default: true
    },
    isStandardConnect: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isActive: {
      handler () {
        if (this.isActive) {
          this.loadConnectContainer()
        }
      },
      immediate: true
    }
  },
  models: {
    stripeAccountSession: {
      variables () {
        return {
          configurationId: this.stripeConfigurationId,
          skip: !this.stripeConfigurationId || !this.isActive
        }
      },
      immediate: false
    }
  },
  methods: {
    async getStripeAccountSession () {
      await this.$nextTick()
      await this.stripeAccountSession.fetch(true)
      return this.stripeAccountSession.value.secret
    },
    async loadConnectContainer () {
      const stripeConnectInstance = loadConnectAndInitialize({
        publishableKey: this.isStandardConnect ? stripeStandardConnectApiToken : stripeAPIToken,
        fetchClientSecret: this.getStripeAccountSession
      })

      await this.$nextTick()
      await this.stripeAccountSession.fetch(true)
      const component = stripeConnectInstance.create(this.type)

      const container = document.getElementById('stripe-session-container')
      container.appendChild(component)
    }
  }
}
</script>
